import { actionTypes } from '../actions';

const initialCreditCards = {
  cards: [],
	error: false,
	loading: false,
}

export const creditCards = (state = {...initialCreditCards}, action) => {
	switch (action.type) {

		case actionTypes.MODIFYING_CARDS:
			return {
				...state,
				cards: [],
				loading: true,
				error: false,
				errorMsg: '',
			};
		case actionTypes.GETING_CARDS_SUCCESS:
			return {
				...state,
				cards: action.cards,
				loading: false,
			};
		case actionTypes.GETING_CARDS_FAILURE:
			return {
				...state,
				error: true,
				errorMsg: action.message,
				loading: false,
			};
		case actionTypes.LOGGED_OFF:
			return {
				...initialCreditCards,
			};

		default:
			return state;
	}
};

export const bankAccount = (state = {banks: [], error: false, loading: false}, action) => {
	switch (action.type) {

		case actionTypes.MODIFYING_BANKS:
			return {
				...state,
				banks: [],
				loading: true,
				error: false,
				errorMsg: '',
			};
		case actionTypes.GETING_BANKS_SUCCESS:
			return {
				...state,
				banks: action.banks,
				loading: false,
			};
		case actionTypes.GETING_BANKS_FAILURE:
			return {
				...state,
				error: true,
				errorMsg: action.message,
				loading: false,
			};
		
		case actionTypes.VERIFICATION_ID_UPLOADED:
			return {
				...state,
				verificationIdComplete: true,
				verificationIdError: '',			
			};
		case actionTypes.VERIFICATION_ID_UPLOAD_FAILURE:
			return {
				...state,
				verificationIdComplete: false,
				verificationIdError: action.errorMsg,
			};
		case actionTypes.CHECK_VERIFICATION_ID_SUCCESS:
			return {
				...state,
				verificationIdComplete: true,
				verificationIdError: '',
				status: action.status,			
			};
		case actionTypes.CHECK_VERIFICATION_ID_FAIL:
			return {
				...state,
				verificationIdComplete: false,
				verificationIdError: action.errorMsg,
			};
		case actionTypes.VERIFICATION_ID_STATUS_RESET:
			return {
				...state,
				verificationIdComplete: false,
				verificationIdError: '',
			};

		default:
			return state;
	}
};

export const stripeToken = (state = { token: '' }, action) => {
  switch (action.type) {

    case actionTypes.GET_STRIPE_KEY_SUCCESS:
      return {
        ...state,
        token: action.payload,
      };
    case actionTypes.GET_STRIPE_KEY_FAILURE:
      return {
        ...state,
        token: ''
      };
    default:
      return state;
  }
};

const topUpInitial = {
  conversionRate: 0,
  firstCardAdded: true,
  telmieBalance: 0,
  topUpPackage: [],
  userCurrency: '',
  paymentMethod: [],
	loading: false,
}

export const topUpInfo = (state = { ...topUpInitial }, action) => {
  switch (action.type) {
    case actionTypes.GET_AMOUNTS:
      return {
        ...state,
        loading: true,
      }
		case actionTypes.GET_AMOUNTS_SUCCESS:
      return {
        ...state,
				...action.payload,
				loading: false,
			}
		case actionTypes.GETING_CARDS_SUCCESS:
			return {
				...state,
				paymentMethod: action.cards,
			};
    default:
      return state;
  }
};

export const widthdrawInfo = (state = {}, action) => {
	switch (action.type) {
	  	case actionTypes.SEND_WITHDRAW_START:
			return {
				...state,
				error: false,
				loading: true,
			}
		case actionTypes.SEND_WITHDRAW_SUCCESS:
			return {
				...state,
				widthdrawInfo: action.payload,
				error: false,
				loading: false,
			}
		case actionTypes.SEND_WITHDRAW_FAILURE:
			return {
				...state,
				widthdrawInfo: action.payload,
				error: true,
				loading: false,
			}	
	  default:
		return state;
	}
  };



// WEBPACK FOOTER //
// ./reducers/wallet.js